// extracted by mini-css-extract-plugin
export default {"root":"jX96N"};